import { userApi } from "../../../redux/api/axiosInstance";

interface OrganizationFormData {
  organizationId?: number;
  name: string;
  address: string;
  contactInfo: string;
  logoUrl: string;
  isActive: boolean;
  subscriptionPlan: string;
  billingInfo: string;
  tenantCode: string;
}

interface AddOrganizationFormData {
  organizationId?: number;
  name: string;
  address: string;
  contactInfo: string;
  logo?: File;
  isActive: boolean;
  subscriptionPlan: string;
  billingInfo: string;
  tenantCode: string;
}

interface UpdateOrganizationFormData {
  organizationId?: number;
  name: string;
  address: string;
  contactInfo: string;
  logo?: File;
  isActive: boolean;
  subscriptionPlan: string;
  billingInfo: string;
  tenantCode: string;
  email?: string;              // HRMS-46: org profile
  payrollFrequency?: string;   // HRMS-46: org profile (country is read-only)
}
export const getAllOrganizations = async (page = 1, pageSize = 10) => {
  try {
    const response = await userApi.get(`Organizations?page=${page}&pageSize=${pageSize}`);
    return response.data;
  } catch (error) {
    console.error("Error fetching organizations:", error);
    throw error;
  }
}
export const getOrganizationById = async (organizationId: number) => {
  try {
    const response = await userApi.get(`Organizations/${organizationId}`);
    return response.data;
  } catch (error) {
    console.error(`Error fetching organization with ID ${organizationId}:`, error);
    throw error;
  }
}
export const addOrganization = async (payload: AddOrganizationFormData) => {
  try {
    const formData = new FormData();

    // Append all form fields to FormData
    if (payload.organizationId !== undefined) {
      formData.append('OrganizationId', payload.organizationId.toString());
    }
    formData.append('Name', payload.name);
    formData.append('Address', payload.address);
    formData.append('ContactInfo', payload.contactInfo);
    formData.append('IsActive', payload.isActive.toString());
    formData.append('SubscriptionPlan', payload.subscriptionPlan);
    formData.append('BillingInfo', payload.billingInfo);
    formData.append('TenantCode', payload.tenantCode);

    // Append logo file if provided
    if (payload.logo) {
      formData.append('Logo', payload.logo);
    }

    const response = await userApi.post('Organizations', formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
    return response.data;
  } catch (error) {
    console.error('Error adding organization:', error);
    throw error;
  }
};
export const updateOrganization = async (organizationId: number, payload: UpdateOrganizationFormData) => {
  try {
    const formData = new FormData();

    // Append all form fields to FormData
    formData.append('OrganizationId', organizationId.toString());
    formData.append('Name', payload.name);
    formData.append('Address', payload.address);
    formData.append('ContactInfo', payload.contactInfo);
    formData.append('IsActive', payload.isActive.toString());
    formData.append('SubscriptionPlan', payload.subscriptionPlan);
    formData.append('BillingInfo', payload.billingInfo);
    formData.append('TenantCode', payload.tenantCode);
    // HRMS-46: preserve/update email + payroll frequency (backend overwrites Email
    // unconditionally, so always send the current value to avoid nulling it).
    if (payload.email !== undefined) formData.append('Email', payload.email ?? '');
    if (payload.payrollFrequency !== undefined) formData.append('PayrollFrequency', payload.payrollFrequency ?? '');

    // Append logo file if provided
    if (payload.logo) {
      formData.append('Logo', payload.logo);
    }

    const response = await userApi.put(`Organizations/${organizationId}`, formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
    return response.data;
  } catch (error) {
    console.error(`Error updating organization with ID ${organizationId}:`, error);
    throw error;
  }
};
export const deleteOrganization = async (organizationId: number) => {
  try {
    const response = await userApi.delete(`Organizations/${organizationId}`);
    return response.data;
  } catch (error) {
    console.error(`Error deleting organization with ID ${organizationId}:`, error);
    throw error;
  }
};
